import { NestedDataDesc } from '../MappingEditorStore';
import { DataDescription } from '@decisions/server/DecisionsFramework/Design/Flow/Mapping';

/**
 * @param desc data desc values
 * @param path location of desired nodes
 * @param returnMatchedParent to return matched parent node when full path match fails.
 * @returns
 */
export function getNestedDataDescByPath(
  desc: Map<string, NestedDataDesc>,
  path: string,
  returnMatchedParent = false
): NestedDataDesc | undefined {
  const split = path.split('.');

  let i = 0;
  let name = split[0];

  let node = desc.get(name);
  while (node && ++i < split.length) {
    name = split[i];
    let nextNode = node.children.get(name);
    if (!nextNode && returnMatchedParent) {
      // return node;
      break;
    }
    node = nextNode;
  }

  return node;
}

/**
 * @param desc data desc values
 * @param path location of desired nodes
 * @param returnMatchedParent to return matched parent node when full path match fails.
 * @returns
 */
export function getNestedDataDescChildrenByPath(
  desc: Map<string, NestedDataDesc>,
  path: string,
  returnMatchedParent = false
) {
  if (!path) {
    return Array.from(desc.values());
  }

  const node = getNestedDataDescByPath(desc, path, returnMatchedParent);
  // not sure what return matched parent will mean in this scenario, where we're getting array of children.
  return node ? Array.from(node.children.values()) : [];
}

export function isConstantDataDescription(data: DataDescription) {
  return (
    (data.FullTypeName === 'DecisionsFramework.Design.Flow.FlowConstantData' && data.Name === 'Flow Data') ||
    (data.FullTypeName === 'DecisionsFramework.Design.Flow.SystemConstants.ConstantData' &&
      data.Name === 'System Constants')
  );
}
// previous flat list attempt logic will still be useful later in finding expanded/ collapsed nodes, I think.
// export function getDataDescByPath(desc: Map<string, DataDescription[]>, path: string, walk = false): DataDescription[] {
//   const found = desc.get(path);
//   if (found) {
//     return found;
//   }

//   if (!path.includes('.') || !walk) {
//     return []; // we hit the root, or a root
//   }

//   path = path.substr(0, path.lastIndexOf('.'));

//   return getDataDescByPath(desc, path);
// }
